import { useMemo } from 'react'
import { useFeatureFlags, useFeatureFlagsWithPrefs } from '@fs/zion-flags'
import flagsConfig, { FLAGS } from './config/feature/flags'

export default function useDiscoveryFeatureFlags() {
  const { labsPref, flagsWithPrefs, flagsWithoutPrefs } = flagsConfig
  const prefs = [labsPref]
  const { data: featureFlagsWithPrefs, loading } = useFeatureFlagsWithPrefs(flagsWithPrefs, null, {
    userPreferences: prefs,
  })
  const featureFlags = useFeatureFlags(flagsWithoutPrefs)

  return useMemo(() => {
    const combinedFlags = { ...featureFlagsWithPrefs, ...featureFlags }

    Object.values(FLAGS).forEach((flag) => {
      if (!combinedFlags[flag]) {
        combinedFlags[flag] = {}
      }
    })

    return { ...combinedFlags, loading }
  }, [featureFlagsWithPrefs, featureFlags, loading])
}
